import React from "react";
import styles from "./workshopInfo.module.css";
import Palette from "../palette/Palette";

export default function WorkshopInfo({
  palette,
  sheetData,
  onDownloadPack,
  fullPaletteCanvas,
  sourceSwatchSize,
  downloadPrefix,
  presetSettings,
  outputType,
}) {
  if (!sheetData || !sheetData.global) return null;

  const { global } = sheetData;
  const {
    blockCounts,
    totalSheets,
    sheetsWide,
    sheetsHigh,
    blocksPerSheet,
    blocksPerImageWidth,
    blocksPerImageHeight,
    pixelBlockSize,
  } = global;

  const showPalette = false;

  console.log("global: ", global);

  const mmWide = blocksPerImageWidth * pixelBlockSize;
  const mmHigh = blocksPerImageHeight * pixelBlockSize;

  const mWide = mmWide / 1000;
  const mHigh = mmHigh / 1000;

  return (
    <div className={styles.outer}>
      {presetSettings && (
        <div className={styles.resets}>
          <h4>{presetSettings.name} - PRESETS</h4>
          <ol>
            {presetSettings.resets.map((reset, i) => (
              <li key={i}>
                <a href={reset.url}>{reset.label}</a>
              </li>
            ))}
          </ol>
        </div>
      )}

      <div>
        <p>{mWide}m wide</p>
        <p>{mHigh}m high</p>
        <p>
          Total sheets: <b>{totalSheets}</b>
        </p>
        <p>
          Sheets: <b>{sheetsWide}</b> across, down:<b>{sheetsHigh}</b>
        </p>
        <p>
          Squares per sheet: <b>{blocksPerSheet}</b>
        </p>
        <p>
          Stickers W:<b>{blocksPerImageWidth}</b> x H:
          <b>{blocksPerImageHeight}</b>
        </p>
        <p>
          Total Stickers: <b>{blocksPerImageWidth * blocksPerImageHeight}</b>
        </p>
        <button className={styles.butt} onClick={onDownloadPack}>
          Download Pack
        </button>
      </div>
      {showPalette && (
        <Palette
          outputType={outputType}
          palette={palette}
          sourceSwatchSize={sourceSwatchSize}
          swatchCounts={blockCounts}
          fullPaletteCanvas={fullPaletteCanvas}
          downloadPrefix={downloadPrefix}
        />
      )}
    </div>
  );
}
